<div class="operator-page">
  <section class="hero-section">
    <div class="container">
      <div class="row align-items-center g-4 g-lg-5">
        <div class="col-lg-6">
          <p class="eyebrow">For teams managing multiple member organizations</p>
          <h1 class="headline mt-primary-text">Built for teams managing multiple associations</h1>
          <p class="subheadline mt-primary-text">
            Standardize member operations, events, payments, and reporting across the organizations you support. MemberTrace gives each client a polished experience while your team works from one operating layer.
          </p>
          <div class="cta-buttons">
            <button mat-flat-button color="primary" routerLink="/contact" [queryParams]="{ inquiryType: 'operator' }">Book a walkthrough</button>
            <button mat-stroked-button color="primary" routerLink="/register-organization">Start free</button>
          </div>
          <p class="hero-note">Start with one organization or book a walkthrough for a multi-organization workflow.</p>
        </div>
        <div class="col-lg-6">
          <div class="hero-image-wrap">
            <img src="/img/dashboard.webp" alt="MemberTrace reporting and membership dashboard" class="hero-image" />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pain-section py-5">
    <div class="container">
      <div class="row text-center section-header-row">
        <div class="col-12">
          <h2 class="section-title">The operator pain MemberTrace solves</h2>
          <p class="section-subtitle">Your team should not need a different spreadsheet and set of tools for every organization.</p>
        </div>
      </div>
      <div class="row g-4">
        <div class="col-md-4" *ngFor="let item of painPoints">
          <div class="info-panel h-100">
            <mat-icon>{{ item.icon }}</mat-icon>
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="operating-layer-section py-5">
    <div class="container">
      <div class="row text-center section-header-row">
        <div class="col-12">
          <h2 class="section-title">One operating layer across your portfolio</h2>
          <p class="section-subtitle">Use the same core system while preserving each organization's branding, workflows, and member experience.</p>
        </div>
      </div>
      <div class="row g-4">
        <div class="col-md-6 col-lg-4" *ngFor="let item of operatingLayer">
          <div class="capability-row">
            <mat-icon>{{ item.icon }}</mat-icon>
            <div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="workflow-section py-5">
    <div class="container">
      <div class="row align-items-center g-4">
        <div class="col-lg-5">
          <h2 class="section-title text-start">A cleaner workflow for operator teams</h2>
          <p class="workflow-copy">
            Start with one organization, then roll the same operating model across the rest of your portfolio.
          </p>
        </div>
        <div class="col-lg-7">
          <ol class="workflow-list">
            <li *ngFor="let item of workflow; let i = index">
              <span>{{ i + 1 }}</span>
              <p>{{ item }}</p>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </section>

  <section class="proof-section py-5">
    <div class="container text-center">
      <h2 class="section-title">Already trusted by professional societies and networks</h2>
      <app-client-logo-strip variant="wrap" wrapPreset="section" />
    </div>
  </section>

  <section class="cta-section py-5">
    <div class="container text-center">
      <h2 class="cta-title">Want to see how this fits your portfolio?</h2>
      <p class="cta-subtitle">Bring your current membership, event, dues, and reporting workflow. We will map where MemberTrace replaces manual work.</p>
      <div class="cta-buttons justify-content-center">
        <button mat-flat-button color="primary" routerLink="/contact" [queryParams]="{ inquiryType: 'operator' }">Book a walkthrough</button>
        <button mat-stroked-button color="primary" routerLink="/pricing">See self-serve pricing</button>
      </div>
      <p class="cta-tertiary">
        Have a multi-organization setup?
        <a routerLink="/contact" [queryParams]="{ inquiryType: 'operator' }" class="cta-tertiary-link">Talk to our team.</a>
      </p>
    </div>
  </section>
</div>
